// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--1Gk2n";
export var footerImg = "footer-module--footerImg--en4a3";
export var sponsors = "footer-module--sponsors--p_gNF";